import { Fragment } from 'react';
import { Stack } from '@mui/material';

import Form from 'components/Form';
import { TGender } from 'apis/account/type';
import { IFormRegister, IFormValues } from 'routes/Main/type';

import RowContainer from '../../components/RowContainer';
import RowContent from './components/RowContentSub';
import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormRegister, IFormValues {
  gender: TGender;
  disabled?: boolean;
}

const Orientation = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <Fragment>
      <SectionTitle title="지각" />
      <RowContainer xs={12}>
        <RowContent title="환청" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1} sx={{ marginLeft: '-10px' }}>
            <Form.MuiRadioGroup
              i18nKey="ORIENTATION"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('orientation.hear.value')}
              onChange={v => setValue('orientation.hear.value', v)}
            />

            <Form.MuiTextField
              required={false}
              disabled={disabled}
              placeholder="구체적인 설명을 적어주세요."
              fullWidth
              {...register('orientation.hear.input')}
            />
          </Stack>
        </RowContent>
        <RowContent title="환시" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1} sx={{ marginLeft: '-10px' }}>
            <Form.MuiRadioGroup
              i18nKey="ORIENTATION"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('orientation.sight.value')}
              onChange={v => setValue('orientation.sight.value', v)}
            />

            <Form.MuiTextField
              required={false}
              disabled={disabled}
              placeholder="구체적인 설명을 적어주세요."
              fullWidth
              {...register('orientation.sight.input')}
            />
          </Stack>
        </RowContent>

        <RowContent title="환미" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1} sx={{ marginLeft: '-10px' }}>
            <Form.MuiRadioGroup
              i18nKey="ORIENTATION"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('orientation.taste.value')}
              onChange={v => setValue('orientation.taste.value', v)}
            />

            <Form.MuiTextField
              required={false}
              disabled={disabled}
              placeholder="구체적인 설명을 적어주세요."
              fullWidth
              {...register('orientation.taste.input')}
            />
          </Stack>
        </RowContent>
        <RowContent title="환촉" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1} sx={{ marginLeft: '-10px' }}>
            <Form.MuiRadioGroup
              i18nKey="ORIENTATION"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('orientation.touch.value')}
              onChange={v => setValue('orientation.touch.value', v)}
            />

            <Form.MuiTextField
              required={false}
              disabled={disabled}
              placeholder="구체적인 설명을 적어주세요."
              fullWidth
              {...register('orientation.touch.input')}
            />
          </Stack>
        </RowContent>

        <RowContent title="환후" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1} sx={{ marginLeft: '-10px' }}>
            <Form.MuiRadioGroup
              i18nKey="ORIENTATION"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('orientation.smell.value')}
              onChange={v => setValue('orientation.smell.value', v)}
            />

            <Form.MuiTextField
              required={false}
              disabled={disabled}
              placeholder="구체적인 설명을 적어주세요."
              fullWidth
              {...register('orientation.smell.input')}
            />
          </Stack>
        </RowContent>
      </RowContainer>
    </Fragment>
  );
};

export default Orientation;
